var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAntiCovertTrackingWhite = function SvgAntiCovertTrackingWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M7.213 1a.5.5 0 0 0-.18.039L1.277 3.582A.48.48 0 0 0 1 4.009c0 3.547.784 5.878 1.945 7.521 1.16 1.643 2.671 2.578 4.035 3.403.145.09.34.09.486 0 1.363-.825 2.874-1.76 4.035-3.403s1.945-3.974 1.945-7.52a.48.48 0 0 0-.277-.428L7.412 1.039A.5.5 0 0 0 7.213 1Zm.01.972 5.275 2.334c-.045 3.222-.757 5.27-1.76 6.69-.975 1.378-2.24 2.206-3.515 2.984-1.276-.778-2.546-1.606-3.52-2.985-1.003-1.42-1.71-3.467-1.755-6.689zm0 2.917c-.94 0-1.711.772-1.711 1.712v.466h-.205a.48.48 0 0 0-.418.467v2.49c0 .244.223.466.467.466H9.09a.485.485 0 0 0 .466-.467V7.534a.485.485 0 0 0-.466-.467h-.156v-.466c0-.94-.771-1.712-1.711-1.712Zm0 .934c.439 0 .778.339.778.778v.466H6.445v-.466c0-.44.339-.778.778-.778ZM5.823 8h2.8v1.555h-2.8z"
  })));
};
export default SvgAntiCovertTrackingWhite;